window.addEventListener('load', function() {
    let items = shorts = document.querySelectorAll('.article_teaser_timeline__horizontal_switchable.short')
    ;[...items].forEach(item => {
        let linkitem = item.querySelector('.article_teaser_timeline__title_link')
        linkitem.addEventListener('click', e => {
            e.preventDefault()
            item.classList.toggle('open')
            let arrow = item.querySelector('.article_teaser_timeline__arrow')
            arrow.textContent = item.classList.contains('open') ? '▲' : '▼'
        })
    })
})